<form [formGroup]="realEstateJustificationForm">
  <div class="formSubHeader">
    <span> Project Justification </span>
  </div>
  <div class="formSubHeader">
    <textarea
      class="textarea textarea-wide"
      formControlName="projectJustification"
      maxlength="2000"
    ></textarea>
  </div>
  <div class="formSubHeader">
    <span
      >{{ projectJustificationLength() }} characters (maximum 2000
      characters)</span
    >
  </div>
  <div class="formSubHeader">
    <span> Reason for Project </span>
  </div>
  <div class="grid-container">
    <div class="grid-item reason">
      <mat-checkbox
        class="stackedCheckBox"
        *ngFor="let reason of projectReasons"
        [value]="reason.value"
        [checked]="realEstateJustificationForm.get('projectReason').value.includes(reason.value)"
        (change)="onCheckboxChange($event, reason.value)"
        [disabled]="reviewMode"
      >
        {{ reason.viewValue }}
      </mat-checkbox>
    </div>
  </div>
</form>
